import type { useRouter } from 'next/navigation';
import type { Dispatch } from 'react';
import { FINDER_ENTRY_PATH } from '../../funnel/constants';
import { discardFunnelRun } from '../../storage';
import type { AnswerAction } from '../actions';

/**
 * Abandon the current run: clear the stored run and its answers, then send the
 * user back to the start. All three parts belong together — dropping any one
 * leaves a restart that merges into the abandoned run's record.
 *
 * Takes `dispatch` rather than reading it from context: the provider's own sync
 * hook is a caller, so reading context here would make this module cyclic with
 * `Context.tsx`.
 */
export function abandonFunnelRun(
  dispatch: Dispatch<AnswerAction>,
  router: ReturnType<typeof useRouter>,
): void {
  discardFunnelRun();
  dispatch({ type: 'RESET_ANSWERS' });
  router.replace(FINDER_ENTRY_PATH);
}
